import { format } from "date-fns";
import { to12HourTime } from "@/components/news-alerts/shared/utils";
import type { ScheduleType, TableAlert } from "./news-alerts.slice";

/**
 * Type representing a NewsAlert from GraphQL response
 * This matches the structure returned by NewsAlertFragment
 */
type NewsAlertGraphQLResponse = {
  id: string | null;
  name: string;
  scheduleType: ScheduleType;
  sendOn: string;
  sendAt: string | unknown;
  timezone: string;
  recipients: string[];
  updatedAt: string;
  createdBy?: {
    name?: string | null;
  } | null;
};

/**
 * Transforms a GraphQL NewsAlert response to TableAlert format
 * @param alert - The news alert from GraphQL response
 * @returns TableAlert formatted for display in the table
 */
export const transformNewsAlertToTableAlert = (
  alert: NewsAlertGraphQLResponse,
): TableAlert => {
  const sendAt =
    typeof alert.sendAt === "string" ? alert.sendAt : String(alert.sendAt);
  const formattedTime = to12HourTime(sendAt);
  const schedule = `${alert.sendOn} at ${formattedTime} ${alert.timezone}`;

  return {
    id: alert.id || "",
    name: alert.name,
    schedule,
    recipients: alert.recipients.length || 0,
    lastUpdated: format(new Date(alert.updatedAt), "MM/dd/yyyy hh:mm a") || "",
    createdBy: alert.createdBy?.name || "",
    scheduleType: alert.scheduleType,
  };
};
